import {detectCountryCode} from "utils/detectCountryCode"

export const CLEAR_USER = "USER/CLEARUSER"
export const SET_USER_INFO = "USER/SETUSERINFO"
export const SET_SHOW_MENU = "USER/SHOWMENU"
export const SET_FORGOT_EMAIL = "USER/SETFORGOTEMAIL"

export const setUserInfo = (userInfo) => ({
  type: SET_USER_INFO,
  userInfo,
});
export const setShowMenu = (showMenu) => ({
  type: SET_SHOW_MENU,
  showMenu,
});

export const setForgotEmail = (forgotEmail) => ({
  type: SET_FORGOT_EMAIL,
  forgotEmail,
})

export const clearUser = () => ({
    type: CLEAR_USER,
})

export const clearAllStorage = () => {

  window.localStorage.clear();

    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0) {
            var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            var p = window.location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            };
            d.shift();
        }
    }
    
}
